import { createHashHistory } from 'history';
import { applyMiddleware, compose, createStore } from 'redux';
import { createReduxHistoryContext } from 'redux-first-history';
import createSagaMiddleware from 'redux-saga';

import rootReducer from '../reducers';
import rootSaga from '../sagas';

const composeEnhancers =
  typeof window === 'object' &&
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ &&
  process.env.NODE_ENV !== 'production'
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
    : compose;

const { createReduxHistory, routerMiddleware, routerReducer } =
  createReduxHistoryContext({
    history: createHashHistory(),
  });
const sagaMiddleware = createSagaMiddleware();

export const store = createStore(
  rootReducer(routerReducer),
  composeEnhancers(applyMiddleware(routerMiddleware, sagaMiddleware)),
);

export const history = createReduxHistory(store);
sagaMiddleware.run(rootSaga);
